// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2bnz_","title":"AfterFrontImage_title__1a122"};